(function () {
  // FINAL storefront coordinates
  var DOLCE_COORDS = { lat: 40.638968, lng: -73.700131 };

  function initDolceMap() {
    var mapEl = document.getElementById('dcMap');
    if (!mapEl) return;

    var map = new google.maps.Map(mapEl, {
      center: DOLCE_COORDS,
      zoom: 19,                   // building-level
      mapTypeId: 'hybrid',        // satellite + labels
      gestureHandling: 'greedy',
      zoomControl: true,
      streetViewControl: true,
      mapTypeControl: false,
      fullscreenControl: false
    });

    new google.maps.Marker({
      position: DOLCE_COORDS,
      map: map,
      title: 'Dolce Confections'
    });
  }

  function loadMapsAndInit() {
    if (window.google && window.google.maps) {
      initDolceMap();
      return;
    }
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAerCDnlIMBeZ0y-k3LSz6FjCqUdyfFy7Q&callback=initDolceMap';
    s.async = true; s.defer = true;
    window.initDolceMap = initDolceMap; // expose for callback
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadMapsAndInit);
  } else {
    loadMapsAndInit();
  }
})();

